<!-- botao padrao

COMO UTILIZAR:

<div class="col-md-6 col-12">
    <div class="float-right">
        <v-button label="Retornar" title="" icon="fa-arrow-left" @click="handleRetorna"></v-button>
        <v-button label="Totalizar" title="" icon="fa-dollar" :nb-btdef="true" @click="handleTotalizar" v-if="!isView"></v-button>
        <v-button label="Mais Ações" @click="handleActions" :actions="moreActions"></v-button>
    </div>
</div>

BOTAO MAIS ACOES:

      <v-button label="Mais Ações" @click="handleActions" :actions="moreActions"></v-button>

      this.moreActions = []
      var act = {}
      if (this.nf.stnf == '10') {
          act = { action: 2, label: 'Imprimir Danfe' }
          this.moreActions.push(act)
          act = { action: 1, label: 'Enviar Email' }
          this.moreActions.push(act)
          act = { action: 3, label: 'Cancelar NF-e' }
          this.moreActions.push(act)
          act = { action: 8, label: 'Enviar Correção' }
          this.moreActions.push(act)
        }


        handleActions (action) {
            //duplica a nota fiscal
            if (action == 4) {
            }
            //enviar email
            if (action == 1) {
                this.handleFormEmailDanfe()
            }
            //imprimir danfe
            if (action == 2) {
                this.imprimirPDF()
            }
        },

-- ALINHAMENTO VERTICAL DO BOTAO

     <div class="row align-items-center">
        <div class="col-md-1 col-1">
          ...
        </div>
        <div class="col-md-1 col-1">
            <v-button label="" title="" icon="fa-trash" @click="handleDeleteRef(index)"></v-button>
        </div>
     </div>


-->

<template>
    <div v-if="!link" class="btn-group align-items-center">
      <!-- BOTAO NORMAL -->
      <div v-if="!actions">
        <a href="javascript:void(0);"
           ref="botao"
           class="btn"
           :customStyle="customStyle"
           :class="{'disabled': disabled, 'nb-btdef': nbBtdef, 'btn-success': success , 'btn-danger': danger, 'btn-video': video, 'nb-btn-video': video && icon === 'fa-youtube-play', 'btn-outline-secondary': !nbBtdef && !success && !danger && !video}"
           style="margin-right: 5px;" :style="customStyle ? customStyle : btStyle"
           data-toggle="tooltip" data-placement="top"
           :title="title"
           :tabindex="tabindex"
           @click="handleClick()"><i v-if="icon" class="fa" :class="icon"  aria-hidden="true"></i> {{ label}}</a>
      </div>

      <!-- BOTAO MAIS ACOES -->
      <div v-if="actions">
        <button class="btn dropdown-toggle"
          :tabindex="tabindex"
          data-toggle="dropdown"
          style="margin-right: 5px"
          :class="{'disabled': disabled, 'nb-btdef': nbBtdef, 'btn-success': success , 'btn-danger': danger, 'btn-outline-secondary': !nbBtdef && !success && !danger}"
          :style="btStyle"><i v-if="icon" class="fa" :class="icon"  aria-hidden="true"></i> {{ _label }} <span class="caret"></span></button>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="btnGroupDrop1">
            <a class="dropdown-item" href="javascript:void(0)"
                v-for="action in actions"
                v-bind:key="action.action"
                @click="handleActions(action.action)">{{ action.label }}</a>
        </div>        
      </div>
    </div>
    <div v-else>
      <a class="pr-2" style="cursor: pointer; color: #0091ea;"
           ref="botao"
          :tabindex="tabindex"
          :title="title"
          data-toggle="tooltip" data-placement="top"
          @click="handleClick"><i v-if="icon" class="fa" :class="icon"  aria-hidden="true"></i> {{ label }} </a>
    </div>

</template>

<script>

export default {
    name: 'v-button',
    props: {
      label: {type: String},
      title: {type: String},
      disabled: {type: Boolean},
      nbBtdef: {type: Boolean},
      success: {type: Boolean},
      danger: {type: Boolean},
      video: {type: Boolean},
      link: {type: Boolean},
      icon: {type: String},
      tabindex: [String, Number],
      actions: {type: Array},
      not_min_width: {type: Boolean},
      customStyle:{type:String}
    },

    data () {
      return {
       
      }
    },

    mounted () {
      this.initTooltip()
    },

    watch: {
      title () {
        this.initTooltip()
      }
    },

    methods: {
      initTooltip () {
        this.$nextTick(() => {
          if (this.$refs.botao) {
            jQuery(this.$refs.botao).tooltip('dispose')
            if (this.title) {
              jQuery(this.$refs.botao).tooltip()
            }
          }
        })
      },

      handleClick () {
        this.$nextTick(() => {
          if (this.$refs.botao) {
            jQuery(this.$refs.botao).tooltip('hide')
          }
        })
        this.$emit('click')
      },

      handleActions (action) {
        this.$emit('click', action)
      },

      focus () {
        if (this.$refs.botao) {
            this.$refs.botao.focus()
        }
      }

    },

    computed: {
      btStyle: function () {
        if (this.label) {
          if (this.not_min_width){
            return ''
          }else{
            return 'min-width: 150px'
          }
        } else {
          return ''
        }
      },

      _label: function () {
        if (this.label) {
          return this.label
        } else {
          return 'Mais Ações'
        }
      },


    },

    beforeDestroy () {
      if (this.$refs.botao) {
        jQuery(this.$refs.botao).tooltip('dispose')
      }
    },


    created () {
     
    },

}
</script>

<style>


.btn.green {
    color: #ffffff;
    background-color: #627d4c;
    border-color: #aeafb1;
  }

.btn.green:hover,
.btn.green:focus,
.btn.green:active,
.btn.green.active {
  color: #ffffff;
  background-color: #759c55;
  border-color: #759c55;
}

.btn.red {
    color: #ffffff;
    background-color: #f71414;
}

.btn.red:hover,
.btn.red:focus,
.btn.red:active,
.btn.red.active {
  color: #ffffff;
  background-color: #fa7272;
  border-color: #fa7272;
}

</style>



// WEBPACK FOOTER //
// src/components/button.vue